export const newHeader = {
  "Como você está se sentindo?": "Como se está a sentir?",
  "Enviar": "Enviar",
  "Se sentindo muito feliz 😆": "A sentir-se muito feliz 😆",
  "Se sentindo feliz 🙂": "A sentir-se feliz 🙂",
  "Se sentindo neutro 😐": "A sentir-se neutro 😐",
  "Se sentindo triste 🙁": "A sentir-se triste 🙁",
  "Se sentindo muito triste 😓": "A sentir-se muito triste 😓",
  "Sentimento enviado.": "Sentimento enviado.",
  "Nos conte porque você está se sentindo assim...": "Diga-nos porque se está a sentir assim...",
  "Minha Equipe": "A Minha Equipa",
  "Sem registro": "Sem registo",
  "Deseja voltar da pausa:": "Deseja voltar da pausa:",
  "Tempo total em pausa:": "Tempo total em pausa:",
  "Selecione o motivo da pausa": "Selecione o motivo da pausa",
  "Marcar Ponto": "Registar Ponto",
  "Marcar Pausa": "Marcar Pausa",
  "Em Pausa": "Em Pausa",
  "Voltar da pausa": "Voltar da pausa",
  "Cancelar": "Cancelar",
  "Confirmar pausa": "Confirmar pausa",
  "Marcar pausa": "Marcar pausa",
  "Início": "Início",
  "Lembretes": "Lembretes",
  "Gestão de tarefas": "Gestão de tarefas",
  "Comunicados": "Comunicados",
  "Documentos": "Documentos",
  "Feedbacks": "Feedbacks",
  "Reuniões 1:1": "Reuniões 1:1",
  "Reembolsos": "Reembolsos",
  "Saldo de horas": "Saldo de horas",
  "Solicitações de ajuste": "Solicitações de ajuste",
  "Férias/Afastamento": "Férias/Afastamento",
  "Histórico de Ponto": "Histórico de Ponto",
  "Espelhos de Ponto": "Espelhos de Ponto",
  "Log de Registros": "Registo de Registos",
  "Modo ponto": "Modo ponto",
  "Minha equipe": "A minha equipa",
  "Gestão de Ponto": "Gestão de Ponto",
  "Gerenciar afastamentos": "Gerir afastamentos",
  "Solicitações da equipe": "Solicitações da equipa",
  "Sobreaviso": "Sobreaviso",
  "Modo escuro": "Modo escuro",
  "Modo claro": "Modo claro",
  "Meu perfil": "O meu perfil",
  "Ouvidoria": "Ouvidoria",
  "Sair": "Sair"
};


// WEBPACK FOOTER //
// ./src/resources/ptPT/newHeader.js